'use strict'

module.exports = require('./quad')
